import { ApplicationState } from '../types';

/** Returns true if the debug mode is enabled for the app */
export const isDebugModeEnabledSelector = (state: ApplicationState) =>
  state.core.debugging.isDebugModeEnabled;
